"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeybindT = exports.Keybind = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const keybind_id_js_1 = require("../../solarxr-protocol/rpc/keybind-id.js");
class Keybind {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsKeybind(bb, obj) {
        return (obj || new Keybind()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsKeybind(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Keybind()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    keybindId() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : keybind_id_js_1.KeybindId.FULL_RESET;
    }
    keybindNameId(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    keybindValue(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    keybindDelay() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    static startKeybind(builder) {
        builder.startObject(4);
    }
    static addKeybindId(builder, keybindId) {
        builder.addFieldInt8(0, keybindId, keybind_id_js_1.KeybindId.FULL_RESET);
    }
    static addKeybindNameId(builder, keybindNameIdOffset) {
        builder.addFieldOffset(1, keybindNameIdOffset, 0);
    }
    static addKeybindValue(builder, keybindValueOffset) {
        builder.addFieldOffset(2, keybindValueOffset, 0);
    }
    static addKeybindDelay(builder, keybindDelay) {
        builder.addFieldFloat32(3, keybindDelay, 0.0);
    }
    static endKeybind(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createKeybind(builder, keybindId, keybindNameIdOffset, keybindValueOffset, keybindDelay) {
        Keybind.startKeybind(builder);
        Keybind.addKeybindId(builder, keybindId);
        Keybind.addKeybindNameId(builder, keybindNameIdOffset);
        Keybind.addKeybindValue(builder, keybindValueOffset);
        Keybind.addKeybindDelay(builder, keybindDelay);
        return Keybind.endKeybind(builder);
    }
    unpack() {
        return new KeybindT(this.keybindId(), this.keybindNameId(), this.keybindValue(), this.keybindDelay());
    }
    unpackTo(_o) {
        _o.keybindId = this.keybindId();
        _o.keybindNameId = this.keybindNameId();
        _o.keybindValue = this.keybindValue();
        _o.keybindDelay = this.keybindDelay();
    }
}
exports.Keybind = Keybind;
class KeybindT {
    constructor(keybindId = keybind_id_js_1.KeybindId.FULL_RESET, keybindNameId = null, keybindValue = null, keybindDelay = 0.0) {
        this.keybindId = keybindId;
        this.keybindNameId = keybindNameId;
        this.keybindValue = keybindValue;
        this.keybindDelay = keybindDelay;
    }
    pack(builder) {
        const keybindNameId = (this.keybindNameId !== null ? builder.createString(this.keybindNameId) : 0);
        const keybindValue = (this.keybindValue !== null ? builder.createString(this.keybindValue) : 0);
        return Keybind.createKeybind(builder, this.keybindId, keybindNameId, keybindValue, this.keybindDelay);
    }
}
exports.KeybindT = KeybindT;
